module.exports = __webpack_public_path__ + "static/media/im.79a99ee3.jpg";